// Force fix Recharge widget text
function forceFixWidget() {
    // Get all elements on the page
    var allElements = document.querySelectorAll('*');
    
    allElements.forEach(function(element) {
        // Check all child nodes including text nodes
        for (var i = 0; i < element.childNodes.length; i++) {
            var child = element.childNodes[i];
            
            // Only process text nodes
            if (child.nodeType === 3) {
                var text = child.nodeValue;
                var updatedText = text;
                
                // Replace the incorrect text
                if (text && text.includes('No commitment')) {
                    updatedText = text.replace('No commitment', '12-month commitment');
                    child.nodeValue = updatedText;
                }
                if (text && text.includes('Cancel anytime')) {
                    updatedText = text.replace('Cancel anytime', 'Cancel with 30 days notice');
                    child.nodeValue = updatedText;
                }
                if (text && text.includes('Free shipping')) {
                    updatedText = text.replace('Free shipping', 'Monthly service included');
                    child.nodeValue = updatedText;
                }
            }
        }
        
        // Also check innerHTML for elements that might contain the text
        if (element.innerHTML && typeof element.innerHTML === 'string') {
            var html = element.innerHTML;
            if (html.includes('No commitment') && !html.includes('script')) {
                element.innerHTML = html.replace('No commitment', '12-month commitment');
            }
            if (html.includes('Cancel anytime') && !html.includes('script')) {
                element.innerHTML = html.replace('Cancel anytime', 'Cancel with 30 days notice');
            }
        }
    });
}

// Run multiple times with delays
setTimeout(forceFixWidget, 100);
setTimeout(forceFixWidget, 500);
setTimeout(forceFixWidget, 1000);
setTimeout(forceFixWidget, 1500);
setTimeout(forceFixWidget, 2000);
setTimeout(forceFixWidget, 3000);

// Run when DOM changes
document.addEventListener('DOMContentLoaded', forceFixWidget);
window.addEventListener('load', forceFixWidget);